import { render, staticRenderFns } from "./remindItem.vue?vue&type=template&id=df0a9f68&scoped=true&"
import script from "./remindItem.vue?vue&type=script&lang=js&"
export * from "./remindItem.vue?vue&type=script&lang=js&"
import style0 from "./remindItem.vue?vue&type=style&index=0&id=df0a9f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0a9f68",
  null
  
)

export default component.exports